import { create } from 'zustand'
import { io } from 'socket.io-client'

export const useSocketStore = create((set, get) => ({
  socket: null,

  connectSocket: (userId) => {
    const socket = io(process.env.REACT_APP_SERVER_URL, {
      query: { userId },
      transports: ['websocket'],
      withCredentials: true,
    })

    socket.on('connect', () => {
      // console.log('✅ 소켓 연결됨')
    })

    set({ socket })
  },

  initSocket: (userId) => {
    if (userId) get().connectSocket(userId)
  },

  disconnectSocket: () => {
    const socket = get().socket
    if (socket) {
      socket.disconnect()
      // console.log('❌ 소켓 연결 종료')
      set({ socket: null })
    }
  },

  joinRoom: (roomId, userInfo) => {
    const socket = get().socket
    if (socket) socket.emit('join_room', { roomId, userInfo })
  },
  leaveRoom: (roomId) => {
    const socket = get().socket
    if (socket) socket.emit('leave_room', roomId)
  },

  onLoginStatus: (cb) => {
    const socket = get().socket
    if (socket) socket.on('login_status', cb)
  },

  getPreviousMessages: (roomId) => {
    const socket = get().socket
    if (socket) socket.emit('get_previous_messages', roomId)
  },
  onPreviousMessages: (cb) => {
    const socket = get().socket
    if (socket) socket.on('previous_messages', cb)
  },
  offPreviousMessages: () => {
    const socket = get().socket
    if (socket) socket.off('previous_messages')
  },

  // 내가 채팅방에 들어가면 상대방 메세지의 is_read가 1로 변하고, 그에 따른 상대방 화면의 변화
  onReadMessage: (cb)=>{
    const socket = get().socket
    if (socket) socket.on('on_read_message', cb)
  },
  offReadMessage: () => {
    const socket = get().socket
    if (socket) socket.off('on_read_message')
  },

  sendMessage: (data) => {
    const socket = get().socket
    if (socket) socket.emit('send_message', data)
  },

  onReceiveMessage: (cb) => {
    const socket = get().socket
    if (socket) socket.on('receive_message', cb)
  },
  offReceiveMessage: () => {
    const socket = get().socket
    if (socket) socket.off('receive_message')
  },

  deleteMessage: (data) => {
    const socket = get().socket
    if (socket) socket.emit('delete_message', data)
  },
  onDeleteMessage: (cb) => {
    const socket = get().socket
    if (socket) socket.on('delete_message_complete', cb)
  },
  offDeleteMessage: () => {
    const socket = get().socket
    if (socket) socket.off('delete_message_complete')
  },

  /* Notification */
  onNotification: (cb) => {
    const socket = get().socket
    if (socket) socket.on('notification', cb)
  },
  offNotification: () => {
    const socket = get().socket
    if (socket) socket.off('notification')
  },

  onError: (cb) => {
    const socket = get().socket
    if (socket) socket.on('error_message', cb)
  },
  offError: () => {
    const socket = get().socket
    if (socket) socket.off('error_message')
  },
}))
